<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                JOB SCHEDULE
              </p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div style="width: 150px; display: flex">
                <div style="width: 6px; background-color: #0BAA00; color: #0BAA00">
                  .
                </div>
                &nbsp;&nbsp;&nbsp;
                <p
                  style="
                    font-size: 15px;
                    margin: auto;
                    font-weight: 300;
                    color: #A5A5A5;
                  "
                >
                  On Schedule
                </p>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div style="width: 150px; display: flex">
                <div
                  style="width: 6px; background-color: #FFA827; color: #FFA827"
                >
                  .
                </div>
                &nbsp;&nbsp;&nbsp;
                <p
                  style="
                    font-size: 15px;
                    margin: auto;
                    font-weight: 300;
                    color: #A5A5A5;
                  "
                >
                  Delay
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg">
                <full-calendar
                  v-if="!displayflag"
                  :events="selectedEvents"
                  style="color: #000000 !important"
                  :firstDay="1"
                  @changeMonth="handleMonthChange"
                  ref="calendar"
                
                  
                >
                </full-calendar>
                <full-calendar
                  v-if="displayflag"
                  :events="selectedEvents"
                  @dayClick="dayClick"
                  @eventClick="eventClick"
                  style="color: #000000 !important"
                  @changeMonth="handleMonthChange"
                  :firstDay="1"
                  ref="calendar"
                  
                >
                </full-calendar>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            v-if="status == 100 || positionid == 4"
            type="primary"
            wide
            @click.native="nextTab"
            class="btn-next"
          >
            NEXT
          </base-button>
          <base-button
            v-else
            type="primary"
            wide
            @click.native="submit()"
            class="btn-next"
          >
            NEXT
          </base-button>
          <p style="color: #EC1B23" v-if="errormsg != ''">{{ errormsg }}</p>
        </div>
      </div>
      <modal :show.sync="modals.noti" class="modal-eprf" centered>
        <b-card
          class="card"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row">
              <div class="col-lg">
                <h4 class="mb-0">{{ tajuk }}</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="modals.noti = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg">
              <!-- :row-style="tableRowClassName" -->
              <el-table
                :data="tableData"
                :header-cell-style="{
                  border: 'transparent',
                  'font-size': '14px',
                  'font-weight': '400',
                  color: '#707070',
                }"
                :cell-style="{ fontColor: '#707070' }"
                style="color: #707070"
              >
                <el-table-column width="50">
                  <div slot-scope="scope">
                    <base-button
                      class="btn-icon btn-round btn-sm"
                      style="color: #ffffff; font-size: 13px"
                      >{{ scope.$index + 1 }}</base-button
                    >
                  </div>
                </el-table-column>
                <el-table-column label="Job No" prop="jobno"> </el-table-column>
                <el-table-column label="Customer" prop="customer">
                </el-table-column>
                <el-table-column label="Date" prop="start"> </el-table-column>
              </el-table>
            </div>
          </div>
          <br /> </b-card
      ></modal>
      <modal :show.sync="modals.generate" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <div class="row">
              <div class="col-lg">
                <img src="@/assets/img/tick.png" width="300" />
              </div>
            </div>
            <br />
            <br />
            <br />
            <div class="row">
              <div class="col-lg">
                <h1>{{ title }}</h1>
              </div>
            </div>

            <div class="row">
              <div class="col-lg">
                <p>
                  {{ message }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <base-button class="btn-primary" @click="redirect('next')"
                  >Done</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </modal>

      <!-- <StatusModal
        :show.sync="modals.successModal"
        :message="message"
        :title="title"
      /> -->
    </div>
  </div>
</template>

<script>
import FullCalendar from "vue-fullcalendar";
import moment from "moment";
import { Modal } from "src/components";
import { BCard } from "bootstrap-vue";
import { Table, TableColumn, DatePicker, TimeSelect } from "element-ui";
import StatusModal from "src/components/StatusModal.vue";

export default {
  props: ["curr"],
  components: {
    StatusModal,
    FullCalendar,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [TimeSelect.name]: TimeSelect,
    [DatePicker.name]: DatePicker,
    BCard,
  },
  data() {
    return {
      demoEvents: [
        {
          title: "Sunny Out of Office",
          start: "2024-08-15",
          end: "2024-08-15",
          time: "09:00",
          customer: "FIMA Buling Sdn Bhd",
          jobno: "NP2111008",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-08-15",
          end: "2024-08-15",
          time: "09:00",
          customer: "FIMA Buling Sdn Bhd",
          jobno: "NP2111008",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-08-15",
          end: "2024-08-15",
          time: "09:00",
          customer: "FIMA Buling Sdn Bhd",
          jobno: "NP2111008",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-08-15",
          end: "2024-08-15",
          time: "09:00",
          customer: "FIMA Buling Sdn Bhd",
          jobno: "NP2111008",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office",
          start: "2024-08-15",
          end: "2024-08-15",
          time: "09:00",
          customer: "FIMA Buling Sdn Bhd",
          jobno: "NP2111008",
          cssClass: ["delay"],
        },
        {
          title: "Sunny Out of Office qwertyuiop",
          start: "2024-08-14",
          end: "2024-08-14",
          time: "09:00",
          customer: "FIMA Buling Sdn Bhd",
          jobno: "NP2111008",
          cssClass: ["delay"],
        },

        {
          title: "hewwo",
          start: "2024-08-20",
          end: "2024-08-20",
          time: "13:00",
          customer: "FIMA Buling Sdn Bhd",
          jobno: "NP2111008",
          cssClass: ["onschedule"],
        },
      ],
      selectedEvents: [],
      tajuk: "",
      tableData: [],
      
      tarikh: "",
      modals: {
        noti: false,
        successModal: false,
        generate: false,
      },
      dateselected: "",
      errormsg: "",
      message: "",
      title: "",
      button: true,
      status: 0,
      positionid: 0,
      displayflag: "",
    };
  },
  methods: {
    redirect(flag) {
      this.modals.generate = false;
      if (flag == "next") {
        setTimeout(() => {
          let parameter = {
            step: "1",
            direction: "depan",
            data: [],
          };
          this.$emit("my-event", parameter);
        }, 500);
      }
    },
    submit() {
      if (this.dateselected == "") {
        this.errormsg = "Please select date";
      } else {
        let obj = {
          date: moment(this.dateselected).format("YYYY-MM-DD"), // YYYY-MM-DD
        };
        this.$http
          .post(
            ":10001/api/v1/outgoing/product/" +
              this.$route.params.refno +
              "/set_ready_date",
            obj
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);

              setTimeout(() => {
                let parameter = {
                  step: "1",
                  direction: "depan",
                  data: [],
                };
                this.$emit("my-event", parameter);
              }, 500);
              // this.title = "PICKUP DETAILS SUCCESSFULLY SUBMITTED";
              // this.message = "Customer has been notified";
              // this.modals.generate = true;
            }
          });
      }
    },
    nextTab() {
      let parameter = {
        step: 1,
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    // moreClick() {},
    eventClick(event, jsEvent, pos) {
      this.tajuk =
        "JOB INFORMATION - " +
        moment(event.end, "YYYY-MM-DD").format("DD MMMM YYYY");

      this.tableData = [
        {
          customer: event.customer,
          jobno: event.jobno,
          start: event.start,
          end: event.end,
          time: "08:00",
        },
      ];
      this.title = event.title;
      this.tarikh = moment(event.start, "YYYY-MM-DD").format("DD MMMM YYYY");
      this.modals.noti = true;
    },
    handleMonthChange(start, end, current) {
      console.log(start);
      console.log(end);
      console.log(current);

      let startmonth = moment(current).startOf("M").format("YYYY-MM-DD");
      let endmonth = moment(current).endOf("M").format("YYYY-MM-DD");

      this.getCalendarData(startmonth, endmonth);
      setTimeout(() => {
      this.getData();

      }, 500)  

    },
    dayClick(e, jsEvent, view) {
      console.log(jsEvent)
      // this.selectedEvents = [];
      let today = moment().subtract(1, "days");
      let dateselect = moment(e);
      let diff = moment(today).isBefore(dateselect);
      // console.log("diff ", diff);
      if (diff == true) {
        this.dateselected = moment(e).format("YYYY-MM-DD");

        for(var i=0; i<this.selectedEvents.length; i++){
          if(this.selectedEvents[i].cssClass[0] == "chosen"){

            this.selectedEvents.splice(i,1);
            let obj = {
              title: "Collection date",
              start: this.dateselected,
              end: this.dateselected,
              // time: "13:00",
              isShow:true,
              customer: "",
              jobno: this.$route.params.refno,
              cssClass: ["chosen"],
              flag: 1
            };

            this.selectedEvents.push(obj)
          }
        }

        // console.log(this.selectedEvents)
        
      } else {
        this.errormsg = "Please select a date from today and onwards";
      }

      // susun collection date always kat atas
      // get data yg sama hari dgn selected date
      // let listindex = []
      // for(var i=0; i<this.selectedEvents.length; i++){
      //   if(moment(e).format("YYYY-MM-DD") == this.selectedEvents[i].start){
      //     console.log("ada sameh")
      //     listindex.push(i)
        
      //   }
      // }
      // // loop the index to swap the first and last data
      // let first = listindex[0]
      // let last = listindex[listindex.length - 1]
      // console.log(first)
      // console.log("first first:", this.selectedEvents[28])


      // var b = this.selectedEvents[first];
      // console.log(b)
      // this.selectedEvents[first] = this.selectedEvents[last];
      // this.selectedEvents[last] = b;

      // let old = this.selectedEvents
      // this.selectedEvents = [] 
      // setTimeout(() => {
      
      // this.selectedEvents = old
      // console.log("first index:", this.selectedEvents[28])
      // console.log("last index", this.selectedEvents[listindex[listindex.length - 1]])
      
      // }, 500)

      

      
    },
    getData() {
      // jumping
      this.$http
        .get(":10001/api/v1/outgoing/product/" + this.$route.params.refno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.dateselected = moment(response.created_at).format(
              "YYYY-MM-DD"
            );

            this.selectedEvents.push(
              {
                title: "Collection Date",
                start: this.dateselected,
                end: this.dateselected,
                time: "",
                customer: "",
                jobno: "",
                cssClass: ["chosen"],
                flag: 1
              }
            )

            this.status = response.status.status;
            if (response.status.status != 100) {
              let parameter = {
                step: (response.status.status - 1).toString(),
                direction: "depan",
                data: [],
              };
              this.$emit("my-event", parameter);
            }
          }
        });
    },
    getCalendarData(start, end) {
      console.log("masuk get calendar")
      this.selectedEvents = []

      this.$http
        .get(
          ":10001/api/v1/outgoing/schedule?start_date=" +
            start +
            "&end_date=" +
            end
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              for (var j = 0; j < response[i].data.length; j++) {
                let obj = {
                  title: response[i].data[j].reference_number,
                  start: moment(response[i].date).format("YYYY-MM-DD"),
                  end: moment(response[i].date).format("YYYY-MM-DD"),

                  customer: "",
                  jobno: response[i].data[j].reference_number,
                  cssClass:
                    response[i].data[j].color == "orange"
                      ? ["delay"]
                      : ["onschedule"],
                  flag: 2
                };
                this.selectedEvents.push(obj)
              }
            }
          }
        });
    },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    
    console.log(this.$route.params.refno);

    let startmonth = moment().startOf("M").format("YYYY-MM-DD");
    let endmonth = moment().endOf("M").format("YYYY-MM-DD");
    console.log(startmonth, endmonth)
    // this.getCalendarData(startmonth, endmonth);
  },
  watch: {
    curr() {
      console.log(this.curr);
      if (this.curr == 1) {
        let parameter = {
          step: "0",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }

      if (this.curr == 2) {
        let parameter = {
          step: "1",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }

      if (this.curr == 3) {
        let parameter = {
          step: "2",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }

      if (this.curr == 4) {
        let parameter = {
          step: "3",
          direction: "depan",
          data: [],
        };
        this.$emit("my-event", parameter);
      }
    },
    positionid() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
  },
};
</script>

<style scoped>
.onschedule {
  background: rgb(11, 170, 0) !important;
  color: #ffffff !important;
}

.delay {
  background: rgb(255, 153, 0) !important;
  color: #ffffff !important;
}

.chosen {
  background: rgb(54, 101, 231) !important;
  color: #ffffff !important;
}
</style>
